function cov_o6ix4wa48() {
  var path = "/app/src/utils/convert-to-snake-case.ts";
  var hash = "5afd3fbf49081c1575643fbeede5acd33d0f6b03";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/utils/convert-to-snake-case.ts",
    statementMap: {
      "0": {
        start: {
          line: 2,
          column: 2
        },
        end: {
          line: 2,
          column: 58
        }
      },
      "1": {
        start: {
          line: 2,
          column: 47
        },
        end: {
          line: 2,
          column: 58
        }
      },
      "2": {
        start: {
          line: 4,
          column: 2
        },
        end: {
          line: 6,
          column: 3
        }
      },
      "3": {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 5,
          column: 39
        }
      },
      "4": {
        start: {
          line: 8,
          column: 2
        },
        end: {
          line: 15,
          column: 9
        }
      },
      "5": {
        start: {
          line: 9,
          column: 21
        },
        end: {
          line: 12,
          column: 20
        }
      },
      "6": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 49
        }
      },
      "7": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 15
        }
      }
    },
    fnMap: {
      "0": {
        name: "convertToSnakeCase",
        decl: {
          start: {
            line: 1,
            column: 16
          },
          end: {
            line: 1,
            column: 34
          }
        },
        loc: {
          start: {
            line: 1,
            column: 56
          },
          end: {
            line: 16,
            column: 1
          }
        },
        line: 1
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 8,
            column: 33
          },
          end: {
            line: 8,
            column: 34
          }
        },
        loc: {
          start: {
            line: 8,
            column: 47
          },
          end: {
            line: 15,
            column: 3
          }
        },
        line: 8
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 58
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 58
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 2
      },
      "1": {
        loc: {
          start: {
            line: 2,
            column: 6
          },
          end: {
            line: 2,
            column: 45
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 2,
            column: 6
          },
          end: {
            line: 2,
            column: 18
          }
        }, {
          start: {
            line: 2,
            column: 22
          },
          end: {
            line: 2,
            column: 45
          }
        }],
        line: 2
      },
      "2": {
        loc: {
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 4,
            column: 2
          },
          end: {
            line: 6,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 4
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "5afd3fbf49081c1575643fbeede5acd33d0f6b03"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_o6ix4wa48 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_o6ix4wa48();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
export function convertToSnakeCase(obj) {
  cov_o6ix4wa48().f[0]++;
  cov_o6ix4wa48().s[0]++;
  if ((cov_o6ix4wa48().b[1][0]++, obj === null) || (cov_o6ix4wa48().b[1][1]++, _typeof(obj) !== 'object')) {
    cov_o6ix4wa48().b[0][0]++;
    cov_o6ix4wa48().s[1]++;
    return obj;
  } else {
    cov_o6ix4wa48().b[0][1]++;
  }
  cov_o6ix4wa48().s[2]++;
  if (Array.isArray(obj)) {
    cov_o6ix4wa48().b[2][0]++;
    cov_o6ix4wa48().s[3]++;
    return obj.map(convertToSnakeCase);
  } else {
    cov_o6ix4wa48().b[2][1]++;
  }
  cov_o6ix4wa48().s[4]++;
  return Object.keys(obj).reduce(function (acc, key) {
    cov_o6ix4wa48().f[1]++;
    var snakeKey = (cov_o6ix4wa48().s[5]++, key.split(/(?=[A-Z])/).join('_').toLowerCase());
    cov_o6ix4wa48().s[6]++;
    acc[snakeKey] = convertToSnakeCase(obj[key]);
    cov_o6ix4wa48().s[7]++;
    return acc;
  }, {});
}